import styled from '~/ui/styled'
import { Flex } from '~components/El'

const PreviewWrap = styled(Flex)`
  flex-direction: row;
`

export default PreviewWrap
